// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_ConferirMovimentacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /caixa/movimentacao/conferir/:id
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_ConferirMovimentacaoResponseDados {
success: boolean
conferido: boolean
}

export type Caixa_ConferirMovimentacaoResponse = ApiResponse<Caixa_ConferirMovimentacaoResponseDados>;

registerResponseContract('Caixa_ConferirMovimentacaoResponse', {
  success:   { type: 'boolean', required: true },
  conferido: { type: 'boolean', required: true },
})
